if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonPrice = this.querySelector('[type="submit"] .price-button-wrapper');
        this.submitButtonSeparator = this.querySelector('[type="submit"] .price-separator');
        this.submitButtonText = this.querySelector('[type="submit"] .atc-text');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButtonPrice.classList.add('hidden');
        this.submitButtonSeparator.classList.add('hidden');
        this.submitButtonText.classList.add('hidden');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              //window.location = window.routes.cart_url;
              window.location = '/checkout';
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              document.dispatchEvent(new Event('cartUpdated'));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.submitButtonPrice.classList.remove('hidden');
            this.submitButtonSeparator.classList.remove('hidden');
            this.submitButtonText.classList.remove('hidden');
            document.dispatchEvent(new Event('cartUpdated'));
            console.log('I AM UPDATED')
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );

  // Subscribe to cart update event
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setTimeout(updateSideCartEntryHub, 500);
  });

  // Update ticket entry header with updated number
  function updateSideCartEntryHub() {
    BUILT_USA_DATA.getActiveGiveawaysByCart((giveaways) => {
        giveaways.forEach((giveaway) => {
            if (giveaway.isActive()) {
                const newPoints = Number(giveaway.getPoints());
                const giveawayHeader = document.querySelector('.sidecart-entry-hub-container');

                if (giveawayHeader) {
                    console.log('Updating header');
                    const entryNum = giveawayHeader.querySelector('.entry-total');

                    if (entryNum) {
                        const oldPoints = parseInt((window.pointsOnLoad ? window.pointsOnLoad.replace(/,/g, '') : '0'), 10) || 0;
                        animateNumber(entryNum, oldPoints, newPoints);
                    }
                }
            }
        });
    });
  }

  // Easing function for smooth effect
  const easeOutQuad = (t) => t * (2 - t);

  // Format numbers with commas
  const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Animate ticket entry numbers in side cart
  function animateNumber(element, start, end) {
    const duration = 1000; // Animation duration in ms
    const frameRate = 60; // Frames per second
    const totalFrames = (duration / 1000) * frameRate;
    let frame = 0;

    const updateNumber = () => {
        frame++;
        const progress = frame / totalFrames;
        const currentNumber = Math.round(start + (end - start) * easeOutQuad(progress));

        element.textContent = numberWithCommas(currentNumber);

        if (frame < totalFrames) {
            requestAnimationFrame(updateNumber);
        }
    };

    updateNumber();
  }

  }
